
import BScroll from "better-scroll";
import MyCard from "@/components/Card";
import LoadMore from 'vux/src/components/load-more/index.vue'

export default {
name: "HotBookList",
data() {
return {
currentPage: 1,
pageSize: 50,
isLoading: false,
loadTip: "",
bscroll: "",
bookdata: []
};
},
components: {
MyCard,
LoadMore
},
mounted() {
this.initScroll();
this.getHotBookList();
},
activated() {

this.refreshScroll();
},
methods: {
initScroll() {
let wrapper = document.querySelector(".p-borrow");
if (!this.bscroll) {
this.bscroll = new BScroll(wrapper, {
pullUpLoad: {
threshold: 50
},
click: true,
bounce: {
top: false,
bottom: false,
left: false,
right: false
}
});
}
this.bscroll.on("pullingUp", () => {
this.getHotBookList();
});
},
refreshScroll() {
if (this.bscroll) {
this.bscroll.refresh();
}
},
getHotBookList() {
this.isLoading = true;
this.loadTip = "加载中";
this.$http("post", "/book/hot", {
current: this.currentPage,
size: this.pageSize
})
.then(res => {
this.isLoading = false;
res.data.forEach(book => {
let bookData = {
bookName: book["ztming"],
isbn: book["isbn"],
marcid: book["marcid"],
infos: [
{
name: "著者",
value: book["zrsming"]
},
{
name: "ISBN",
value: book["isbn"]
},
{
name: "出版社",
value: book["cbzhe"]
},
{
name: "主题",
value: book["zti"]
}
]
};
this.bookdata.push(bookData);
});
this.$nextTick(() => {
this.currentPage += 1;
if (res.data.length === 0) {
this.bscroll.closePullUp();
this.loadTip = "暂无数据";
} else {
this.bscroll.finishPullUp();
this.loadTip = "";
}
this.bscroll.refresh();
});
})
.catch(() => {
this.isLoading = false;
this.loadTip = "";
});
},
jumpBookDetail(params, bookdata) {
try {
sessionStorage.setItem("bookInfo", JSON.stringify(bookdata));
} catch (error) {

}
this.$router.push({
path: "/bookDetail",
query: {
isbn: params.isbn,
marcid: params.marcid
}
});
}
}
};
